<div class="Footer_bottom">
  <section class="first-section">
    <div class="container-fluid pe-0 overflow-hidden">
      <div class="row justify-content-end align-items-center">
        <div class="col-md-5">
  <div class="content-box" style="padding: 0 40px;">
    <div>
        <img src="../../../assets/images/arrow-left.svg" class="img-fluid pointer" [routerLink]="currentRoute.includes('impact-stories') ? '/impact-stories' : '/home'" alt="">
    </div>
    <h1 class="page-hero-title text-white">{{impactStoriesData[0].title}}</h1>
    <p style="font-size: 14px; color: #F9F9F9;">{{impactStoriesData[0].createdAt | date: 'd MMM y'}}</p>
  </div>
        </div>
        <div class="col-md-6 ps-0 text-end">
          <img [src]="impactStoriesData[0].banner" class="img-fluid w-100 banner-img" alt="">
        </div>
      </div>
    </div>
  </section>

  <section class="para-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
              <p class="para-1 mb-3 color-44" [innerHTML]="impactStoriesData[0].description"></p>
            </div>
        </div>
    </div>
  </section>

  <section class="my-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6 col-12" *ngIf="impactStoriesData[0].link">
          <iframe class="iframe_video w-100" width="500" height="300" [src]="url"
            title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </section>


  <section>
    <div class="container">
      <div class="row" >
        <div class="col-12">
          <h2 class="text-center related-title" style="color: #00625F;">Related Stories</h2>
        </div>
        <ng-container *ngFor="let items of relatedStories; let i = index">
          <div class="col-md-4" style="margin-bottom: 35px;" *ngIf="i <= 5">
    <div class="card-bg h-100">
      <div class="card h-100 card-hover border-0 shadow-sm">
        <div class="position-relative main-img">

          <img [src]="items?.banner" class="card-img-top h-100 rounded-0 img-fluid card-img" alt="...">
        </div>
        <div class="card-body" style="background-color: #00625F;">
          <h6 class="text-white">{{items?.title}}</h6>
          <p class="card-text text-white" [innerHTML]="stripHtmlTagsForCard(items?.description,150)"></p>

        </div>
        <div class="text-center card-footer" style="background-color: #00625F;">
          <button class="btn read-btn mb-2 text-white rounded-pill" style="background-color: #47d985; border: 1px solid #47d985;" routerLink="/related-stories" [queryParams]="{ id: items?.id}">Read More</button>
        </div>
       </div>
    </div>
          </div>
          </ng-container>
      </div>
    </div>
</section>
</div>